import React from 'react';

interface RiskMetricsCardProps {
  title: string;
  value: string;
  subtitle: string;
  status: 'good' | 'warning' | 'critical' | 'neutral';
  icon: React.ReactNode;
}

const RiskMetricsCard: React.FC<RiskMetricsCardProps> = ({
  title,
  value,
  subtitle,
  status,
  icon
}) => {
  const getStatusColor = (status: string) => {
    switch (status) {
      case 'good':
        return 'text-success-custom bg-success-subtle border border-success-subtle';
      case 'warning':
        return 'text-warning-custom bg-warning-subtle border border-warning-subtle';
      case 'critical':
        return 'text-error-custom bg-error-subtle border border-error-subtle';
      default:
        return 'text-secondary-custom card border border-primary-custom';
    }
  };

  const getValueColor = (status: string) => {
    switch (status) {
      case 'good':
        return 'text-success-custom';
      case 'warning':
        return 'text-warning-custom';
      case 'critical':
        return 'text-error-custom';
      default:
        return 'text-primary-custom';
    }
  };

  const getIconColor = (status: string) => {
    switch (status) {
      case 'good':
        return 'text-green-500';
      case 'warning':
        return 'text-yellow-500';
      case 'critical':
        return 'text-red-500';
      default:
        return 'text-gray-500';
    }
  };

  return (
    <div className={`rounded-lg p-4 ${getStatusColor(status)}`}>
      <div className="flex items-center justify-between">
        <div className="flex-1">
          <p className="text-body font-medium text-secondary-custom">{title}</p>
          <p className={`text-data-large font-bold ${getValueColor(status)}`}>
            {value}
          </p>
          <p className="text-caption text-tertiary-custom mt-1">{subtitle}</p>
        </div>
        <div className={`flex-shrink-0 ${getIconColor(status)}`}>
          {icon}
        </div>
      </div>
    </div>
  );
};

export default RiskMetricsCard; 